// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"17":"993c8585","441":"191ace8f"}[chunkId] + ".css";
};